module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "description__wrapper"
  }, [_c('div', {
    staticClass: "description__column main"
  }, [_c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.mainContent),
      expression: "mainContent"
    }],
    ref: "mainContent",
    staticClass: "main__content"
  })]), _c('div', {
    staticClass: "description__column aside"
  }, [_c('div', {
    ref: "asideBg",
    staticClass: "aside__background"
  }), _c('div', {
    ref: "asideGraphic",
    staticClass: "aside__graphic"
  }), _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.asideContent),
      expression: "asideContent"
    }],
    ref: "asideContent",
    staticClass: "aside__content"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3379be55","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/description.vue
// module id = 474
// module chunks = 0